/* Kaló — Theme JS */
(function(){
  var FREE_SHIPPING_THRESHOLD=39;

  // Header scroll + progress bar + mobile sticky bar
  var header=document.getElementById('header');
  var mbar=document.getElementById('mbar');
  window.addEventListener('scroll',function(){
    if(header)header.classList.toggle('scrolled',window.scrollY>40);
    var h=document.documentElement;
    var p=document.getElementById('progress');
    if(p)p.style.width=(h.scrollTop/(h.scrollHeight-h.clientHeight)*100)+'%';
    if(mbar)mbar.classList.toggle('on',window.scrollY>700);
  });

  // Mobile nav menu toggle
  var hamburger=document.getElementById('hamburgerBtn');
  var navLinks=document.getElementById('navLinks');
  if(hamburger && navLinks){
    hamburger.addEventListener('click',function(){
      var open=navLinks.classList.toggle('open');
      hamburger.classList.toggle('open',open);
      hamburger.setAttribute('aria-expanded',open?'true':'false');
    });
    navLinks.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click',function(){
        navLinks.classList.remove('open');
        hamburger.classList.remove('open');
        hamburger.setAttribute('aria-expanded','false');
      });
    });
    document.addEventListener('click',function(e){
      if(!navLinks.classList.contains('open'))return;
      if(navLinks.contains(e.target)||hamburger.contains(e.target))return;
      navLinks.classList.remove('open');
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded','false');
    });
  }

  // Announcement rotation
  var msgs=document.querySelectorAll('.announce .msg');
  if(msgs.length>1){var mi=0;setInterval(function(){msgs[mi].classList.remove('on');mi=(mi+1)%msgs.length;msgs[mi].classList.add('on')},3800)}

  // Reveal on scroll
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el)});

  // Cart drawer open/close
  window.openCart=function(){var d=document.getElementById('drawer'),o=document.getElementById('overlay');if(d)d.classList.add('on');if(o)o.classList.add('on')};
  window.closeCart=function(){var d=document.getElementById('drawer'),o=document.getElementById('overlay');if(d)d.classList.remove('on');if(o)o.classList.remove('on')};
  var ov=document.getElementById('overlay');
  if(ov)ov.onclick=window.closeCart;
  var cb=document.getElementById('cartBtn');
  if(cb)cb.onclick=window.openCart;

  // ---- Live Shopify cart (AJAX Cart API) ----
  function moneyFmt(cents){return (cents/100).toFixed(2)}

  window.renderCart=function(cart){
    var countEl=document.getElementById('cartCount');
    var itemsEl=document.getElementById('drawerItems');
    var subEl=document.getElementById('subtotal');
    var fillEl=document.getElementById('shipFill');
    var msgEl=document.getElementById('shipMsg');
    if(!itemsEl)return;
    if(countEl)countEl.textContent=cart.item_count;
    if(subEl)subEl.textContent=moneyFmt(cart.total_price);

    if(!cart.items.length){
      itemsEl.innerHTML='<div class="empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>Your bag is empty.<br>Make it personal.</div>';
    }else{
      itemsEl.innerHTML=cart.items.map(function(it,i){
        var name=it.properties && it.properties['Name'] ? it.properties['Name'] : '';
        var thumb=it.image?'<img src="'+it.image+'&width=160" alt="">':'<span class="fallback">'+(name?name.slice(0,2):'Aa')+'</span>';
        var variantBits=[it.variant_title,name?'"'+name+'"':null,it.properties&&it.properties['Font']?it.properties['Font']:null].filter(Boolean).join(' · ');
        return '<div class="ci-row">'+
          '<div class="ci-thumb">'+thumb+'</div>'+
          '<div class="ci-info"><h4>'+it.product_title+'</h4><div class="v">'+variantBits+'</div>'+
          '<div class="qty"><button type="button" onclick="changeCartLine('+(i+1)+','+(it.quantity-1)+')">−</button>'+it.quantity+'<button type="button" onclick="changeCartLine('+(i+1)+','+(it.quantity+1)+')">+</button></div>'+
          '</div>'+
          '<div class="ci-price">$'+moneyFmt(it.final_line_price)+'<button class="rm" type="button" onclick="changeCartLine('+(i+1)+',0)">Remove</button></div>'+
        '</div>';
      }).join('');
    }

    if(fillEl)fillEl.style.width=Math.min(100,(cart.total_price/100/FREE_SHIPPING_THRESHOLD)*100)+'%';
    if(msgEl){
      var remaining=FREE_SHIPPING_THRESHOLD-(cart.total_price/100);
      if(remaining<=0)msgEl.innerHTML='✦ <b>You’ve unlocked free shipping!</b>';
      else if(cart.total_price>0)msgEl.innerHTML='You\'re <b>$'+remaining.toFixed(2)+'</b> away from free shipping';
      else msgEl.innerHTML='Free shipping over <b>$'+FREE_SHIPPING_THRESHOLD+'</b>';
    }
  };

  window.fetchCart=function(){
    fetch('/cart.js').then(function(r){return r.json()}).then(window.renderCart).catch(function(){});
  };

  window.changeCartLine=function(line,qty){
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({line:line,quantity:qty})
    }).then(function(r){return r.json()}).then(window.renderCart).catch(function(){});
  };

  window.addToCartAjax=function(form){
    var formData=new FormData(form);
    var body={};
    formData.forEach(function(v,k){
      if(k.indexOf('properties[')===0){
        body.properties=body.properties||{};
        body.properties[k.slice(11,-1)]=v;
      }else{
        body[k]=v;
      }
    });
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify(body)
    }).then(function(r){
      if(!r.ok)return r.json().then(function(e){throw new Error(e.description||'Could not add to bag')});
      return r.json();
    }).then(function(item){
      window.fetchCart();
      window.openCart();
      window.showToast('Added to bag ✦');
      qty=1;
      var v=document.getElementById('qtyVal'),i=document.getElementById('qtyInput');
      if(v)v.textContent=1;if(i)i.value=1;
    }).catch(function(err){
      window.showToast(err.message||'Please enter a name first ✦',true);
    });
  };

  // Wire up the product form (if present) to submit via AJAX instead of a full page reload
  var pform=document.getElementById('kaloProductForm');
  if(pform){
    pform.addEventListener('submit',function(e){
      e.preventDefault();
      var nameInput=document.getElementById('nameInput');
      if(nameInput && !nameInput.value.trim()){
        window.showToast('Please enter a name first ✦',true);
        nameInput.focus();
        return;
      }
      window.addToCartAjax(pform);
    });
  }

  // Load current cart on every page so the drawer is accurate even after a normal navigation
  window.fetchCart();

  // Product page helpers — image gallery
  window.swapImg=function(el,src){
    document.querySelectorAll('.thumb').forEach(function(t){t.classList.remove('on')});
    el.classList.add('on');
    var m=document.getElementById('mainPhoto');
    if(m)m.src=src;
  };

  var qty=1;
  window.stepQty=function(d){
    qty=Math.max(1,qty+d);
    var v=document.getElementById('qtyVal');
    var i=document.getElementById('qtyInput');
    if(v)v.textContent=qty;
    if(i)i.value=qty;
  };

  // Font picker
  window.pickFont=function(el){
    document.querySelectorAll('.fontchip').forEach(function(c){c.classList.remove('on')});
    el.classList.add('on');
    var label=document.getElementById('fontLabel');
    var input=document.getElementById('fontInput');
    if(label)label.textContent='— '+el.dataset.name;
    if(input)input.value=el.dataset.name;
    var preview=document.getElementById('previewName');
    if(preview)preview.style.fontFamily=el.dataset.font;
    window.updateNamePreview();
  };

  // Colour picker
  window.pickColour=function(el,variantId,name){
    document.querySelectorAll('.finish').forEach(function(f){f.classList.remove('on')});
    el.classList.add('on');
    var variantInput=document.getElementById('variantId');
    if(variantInput)variantInput.value=variantId;
    var label=document.getElementById('colourLabel');
    if(label)label.textContent='— '+name;
    var lp=document.getElementById('livePreview');
    if(lp){
      var chain=name==='Silver'?'#B9B9B9':name==='Rose Gold'?'#D69E83':'#D8A24A';
      lp.style.setProperty('--chain',chain);
      var grad=name==='Silver'?'linear-gradient(135deg,#EDEDED,#A6A6A6)':name==='Rose Gold'?'linear-gradient(135deg,#E8C0AE,#C98A6E)':'linear-gradient(135deg,#E8C98A,#C9912F)';
      var pn=document.getElementById('previewName');
      if(pn){pn.style.background=grad;pn.style.webkitBackgroundClip='text';pn.style.backgroundClip='text'}
    }
  };

  // Gallery: photo vs live-preview toggle
  window.showPhoto=function(el,src){
    document.querySelectorAll('.thumb').forEach(function(t){t.classList.remove('on')});
    el.classList.add('on');
    var pg=document.getElementById('photoGallery'),lp=document.getElementById('livePreview'),mp=document.getElementById('mainPhoto');
    if(pg)pg.style.display='block';
    if(lp)lp.style.display='none';
    if(mp&&src)mp.src=src;
  };
  window.showPreview=function(el){
    document.querySelectorAll('.thumb').forEach(function(t){t.classList.remove('on')});
    el.classList.add('on');
    var pg=document.getElementById('photoGallery'),lp=document.getElementById('livePreview');
    if(pg)pg.style.display='none';
    if(lp)lp.style.display='flex';
  };

  // Toast
  var tt;
  window.showToast=function(t,warn){
    var el=document.getElementById('toast');
    if(!el)return;
    el.textContent=t;el.className='toast on'+(warn?' warn':'');
    clearTimeout(tt);tt=setTimeout(function(){el.classList.remove('on')},2400);
  };

  // Live name preview with dangling-chain physics
  var theta=0,omega=0,lastT=performance.now();
  var reduceMo=matchMedia('(prefers-reduced-motion:reduce)').matches;
  window.updateNamePreview=function(){
    var input=document.getElementById('nameInput');
    var el=document.getElementById('previewName');
    if(!el||!input)return;
    var v=input.value.trim();
    el.textContent=v||'Aria';
    el.style.opacity=v?'1':'.55';
    if(!reduceMo)omega+=(Math.random()*0.85+0.55)*(Math.random()<0.5?-1:1);
  };
  function swing(now){
    var d=document.getElementById('dangle');
    if(d){
      var dt=Math.min(0.032,(now-lastT)/1000);lastT=now;
      omega+=(-46*theta-4.7*omega)*dt;theta+=omega*dt;
      if(theta>0.34){theta=0.34;omega*=-0.3}if(theta<-0.34){theta=-0.34;omega*=-0.3}
      var idle=reduceMo?0:1.0*Math.sin(now/720);
      d.style.transform='translateX(-50%) rotate('+(theta*57.2958+idle).toFixed(2)+'deg)';
    }
    requestAnimationFrame(swing);
  }
  if(document.getElementById('dangle')){requestAnimationFrame(swing);updateNamePreview();}
})();
